module.exports = __webpack_public_path__ + "static/img/cchat.5d3dc712.svg";